export default function(script, style) {
  return `
  <template>
    <iframe :src="src" ref="iframe"></iframe>
  </template>
  <script>
  export default {
    data() {
      return {
        businessCode: '', //业务请求代码，每次创建是生成一个uuid
        itemCode: '', //事项代码
        action: 'create', //表单动作，只能取create(新建),modify(修改),view(查看)三者之一
        itemUrl: '', //获取事项数据的接口基地址
        extension: '' //JSON格式的字符串，key加双引号
        src: null
      };
    },
    mounted() {
      window.addEventListener('message',this.save);
      let srcStr = this.itemUrl + '/' + this.businessCode + '/' + this.itemCode + '/' + this.action;
      if(extension)
        src+='?extension='+encodeURI(extension);
      this.src = srcStr;
    },
    methods: {
      ${script}
      save(data) {
        console.log(data);
      }
    }
  };
  </script>
  <style lang="css">
    ${style}
  </style> 
  `;
}
